import { normalizeBacktestTrades } from '../../../../../utils/backtestTrades';

/**
 * Backward-compatible export used by StrategyBuilder.
 */
export const normalizeTrades = normalizeBacktestTrades;
